import React from 'react';
import Cta from '../../subcomponents/Cta';
import SmartImage from '../../subcomponents/SmartImage';
import findAltText from '../../utils';


import './genericOrVoucher.scss';

const checkCampaignID = (id) => {
  if (window) {
    if (parseInt(window.campaign_data.campaign_id, 10) === parseInt(id, 10)) return true;
  }
  return false;
};

const GenericOrVoucher = ({
  element, url, campaignType, order, version,
 }) => {
  const {
    titleColor, 
    mobileTitleColor, 
    useMobileText, 
    useTitle, 
    useText, 
    genericOrVoucherNumber,
    backgroundColor,
    useGradient, 
    backgroundGradient, 
    gradientDirection,
    hide, 
    content, 
    cta, 
    addCta, 
    textColor, 
    mobileTextColor,
    addVoucher, 
    voucherColor, 
    voucherTextColor, 
    position, 
    anchorName, 
    titleHTag,
    addImage, 
    imageType, 
    backgroundImage, 
    backgroundContent, 
    type, 
    noBackground,
    roundedCorners, 
    removeArrow,
  } = element;
  const { slug, imagePattern } = url;
  const translations = window.campaign_data.campaign_translations.blocks;
  const uppercaseLetters = url.generalData ?
    url.generalData.uppercaseLetters
    : false;

  let displayTitleColor = titleColor;
  let displayTextColor = textColor;
  if (useMobileText && window.innerWidth < 768) displayTitleColor = mobileTitleColor;
  if (useMobileText && window.innerWidth < 768) displayTextColor = mobileTextColor;
  const roundTheCorners = (campaignType === 'general' && roundedCorners) ? 'rounded-corners' : '';

  // change HTML tag of the component title for seo purpose
  const classes = uppercaseLetters ? 'generic-title title title--uppercase' : 'generic-title title';
  const titleObj = {
    h2: <h2 className={classes} style={{ color: displayTitleColor }}>{translations[`${content}title`]}</h2>,
    h3: <h3 className={classes} style={{ color: displayTitleColor }}>{translations[`${content}title`]}</h3>,
    p: <p className={classes} style={{ color: displayTitleColor }}>{translations[`${content}title`]}</p>,
  };
  const title = titleObj[titleHTag];

  const stylelist = ['mainWidth'];
  if (campaignType === 'sale' || noBackground) { stylelist.push('sale'); }
  if (backgroundImage) { stylelist.push('background-image-style'); }
  if (position === 'center') {
    stylelist.push('genericOrVoucher--center');
    } else { stylelist.push('genericOrVoucher--left'); }
  if (campaignType === 'general' && !noBackground && !addImage) { stylelist.push('general-center'); }
  if (position === 'right' && (noBackground || !backgroundImage)) { stylelist.push('mainWidth-hackRightSide'); }
  let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
        }
  let component = null;
  if (!hide) {
    component = (
      <section
        id={campaignType === 'sale' || campaignType === 'general' ? anchorName : ''}
        className={`component genericOrVoucher-section ${(checkCampaignID(1302) || !noBackground || backgroundImage) && 'genericOrVoucher-section-noPadding'}`}
        style={styler}
        dataorder={order}
        datatype={type}
      >
        {(backgroundImage || (campaignType === 'general' && !noBackground)) &&
        <SmartImage
          slug={slug}
          name={campaignType === 'general' ? `350-generic-voucher${genericOrVoucherNumber}${imagePattern}` : `${backgroundContent}.jpg`}
          version={version}
          campaignType={campaignType}
          className={campaignType === 'general' ? 'heightBackground' : ''}
          alt={findAltText(`Generic Voucher Background ${genericOrVoucherNumber}`, translations[`${content}title`])}
        />
        }
        <div
          className={stylelist.join(' ')}
        >
          {addImage && (position === 'right' || (window.innerWidth < 768 && position !== 'center')) &&
            <div className="generic-image-holder generic-image-holder--left">
              <picture>
                <source media="(min-width: 768px)" srcSet={`${slug}${content}/desktop/${content}${imageType}?version=${version}`} />
                <img src={`${slug}${content}/mobile/${content}${imageType}?version=${version}`} alt={findAltText(`Generic Voucher Image ${genericOrVoucherNumber}`, translations[`${content}title`])} />
              </picture>
            </div>
          }
          <div className={`generic-text-holder ${position === 'right' && 'generic-text-holder-hackRightSide'}`}>
            {useTitle && title }
            {useText &&
            <p className="generic-text text" style={{ color: displayTextColor }}>{translations[`${content}text`]}</p>
            }
            {addCta &&
            <Cta
              className={`generic-cta ${roundTheCorners}`}
              url={translations[`${content}link`]}
              translation={translations[`${content}ctatext`] ? translations[`${content}ctatext`] : 'BUTTON'}
              backgroundColor={cta.ctaBackgroundColor}
              textColor={cta.ctaTextColor}
              ctaArrowColor={cta.ctaArrowColor}
              borderColor={cta.ctaBorderColor}
              noArrow={removeArrow}
              campaignType={campaignType}
            />
            }
            {addVoucher &&
              <div className="voucher" style={{ border: `2px solid ${voucherColor}` }}>
                <p style={{ color: voucherColor }}>{translations[`${content}number`]}</p>
              </div>
            }
            {addVoucher &&
              <p className="voucher-text text" style={{ color: voucherTextColor }}>{translations[`${content}notetext`]}</p>
            }
          </div>
          {addImage && position === 'left' && window.innerWidth >= 768 &&
            <div className="generic-image-holder generic-image-holder--right">
              <picture>
                <source media="(min-width: 768px)" srcSet={`${slug}${content}/desktop/${content}${imageType}?version=${version}`} />
                <img src={`${slug}${content}/mobile/${content}${imageType}?version=${version}`} alt={findAltText(`Generic Voucher Image ${genericOrVoucherNumber}`, translations[`${content}title`])} />
              </picture>
            </div>
          }
        </div>
      </section>
    );
  }
return (
    component
  );
};

export default GenericOrVoucher;
